// extracted by mini-css-extract-plugin
export default {"actionDetailWrapPopup":"PhaseTable_actionDetailWrapPopup__6NE8y","buttonPopupConfirm":"PhaseTable_buttonPopupConfirm__HBJpU"};